import React from 'react';
import { ResponsivePie } from '@nivo/pie';
import cn from 'classnames';

import { getTranslation } from 'helpers/getTranslation';

import { Typography } from 'components/shared/Typography';
import { Select } from 'components/shared/Select';

import styles from './RegistrationsCard.module.scss';

const periodOptions = [
  {
    label: 'Day',
    value: 'day',
  },
  {
    label: 'Week',
    value: 'week',
  },
  {
    label: 'Month',
    value: 'month',
  },
  {
    label: 'Year',
    value: 'year',
  },
];

const CenteredMetric = ({
  studentsCount,
  centerX,
  centerY,
}: {
  studentsCount: any;
  centerX: any;
  centerY: any;
}) => {
  if (studentsCount) {
    return (
      <text
        x={centerX}
        y={centerY}
        textAnchor="middle"
        dominantBaseline="central"
        style={{
          fontSize: 20,
          lineHeight: 24,
          fontFamily: 'Inter',
          fontWeight: 600,
          fill: '#021930',
        }}
      >
        {studentsCount}
      </text>
    );
  }
};

const Tooltip = ({ datum }: { datum: any }) => {
  const { value } = datum;

  return (
    <div className={styles.tooltip}>
      <Typography
        className={styles.tooltipText}
        variant="caption"
        mode="compact"
      >
        {getTranslation('dashboard_page.progress_card.students_value', {
          value,
        })}
      </Typography>
    </div>
  );
};

const RegistrationsCard = ({
  className,
  data,
  period,
  studentsCount,
  onChangePeriod,
}: {
  className: any;
  data: any;
  period: any;
  studentsCount: any;
  onChangePeriod: any;
}) => (
  <div className={cn(styles.card, className)}>
    <div className={styles.header}>
      <Typography
        className={styles.title}
        variant="body1"
        weight="medium"
        mode="compact"
      >
        Registrations
      </Typography>
      <Select
        className={styles.select}
        value={period}
        options={periodOptions}
        onChange={onChangePeriod}
      />
    </div>
    <div className={styles.inner}>
      <ResponsivePie
        colors={{ datum: 'data.color' }}
        data={data}
        margin={{ top: 20, right: 0, bottom: 40, left: 0 }}
        innerRadius={0.83}
        padAngle={0.7}
        cornerRadius={3}
        activeOuterRadiusOffset={8}
        enableArcLabels={false}
        enableArcLinkLabels={false}
        theme={{
          legends: {
            text: {
              fontFamily: 'Inter',
              fontSize: 12,
              lineHeight: 14,
              fontWeight: 500,
            },
          },
        }}
        layers={[
          'arcLinkLabels',
          'arcs',
          'arcLabels',
          'legends',
          (props: any) => (
            <CenteredMetric {...props} studentsCount={studentsCount} />
          ),
        ]}
        tooltip={({ datum }: { datum: any }) => <Tooltip datum={datum} />}
        legends={[
          {
            anchor: 'bottom',
            direction: 'row',
            justify: false,
            translateX: 0,
            translateY: 40,
            itemsSpacing: 110,
            itemWidth: 85,
            itemHeight: 14,
            itemTextColor: '#021930',
            itemDirection: 'left-to-right',
            itemOpacity: 1,
            symbolSize: 12,
            symbolShape: 'circle',
          },
        ]}
      />
    </div>
  </div>
);

export default React.memo(RegistrationsCard) as any;
